import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("hw_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function saveAuth(token, user) {
  localStorage.setItem("hw_token", token);
  localStorage.setItem("hw_user", JSON.stringify(user));
}
export function clearAuth() {
  localStorage.removeItem("hw_token");
  localStorage.removeItem("hw_user");
}
export function getStoredUser() {
  try { return JSON.parse(localStorage.getItem("hw_user") || "null"); }
  catch { return null; }
}
export function getToken() { return localStorage.getItem("hw_token"); }
